export default function MySQL_SELECT() {
  return (
    <div>
      <h2>MySQL_SELECT</h2>    </div>
  );
}